<template>
  <div>
    <el-button plain type="primary" size="small" v-if="!isView" @click="clickRefWork">关联活动</el-button>
    <el-table
      :data="workList2"
      border
      :header-cell-style="{
        background:'#F9F9FB',
        color:'#606266'
      }"
      :summary-method="(param) => getSummaries(param, ['quantity', 'ptotal'])"
      show-summary
      style="width: 100%;margin-top:10px"
      ref="refTable"
      :default-expand-all="false">
      <el-table-column type="expand" width="90px">
        <template slot-scope="props">
          <el-table
            :data="props.row.ofoWorkResourceList"
            :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
            style="margin-left:50px;width:calc(100% - 50px)"
          >
            <el-table-column prop="ofrresourceName" label="名称"></el-table-column>
            <el-table-column prop="cbowhName" label="位置"></el-table-column>
            <el-table-column prop="quantity" label="数量
            " align="right" header-align="center"></el-table-column>
            <el-table-column prop="total" label="金额" align="right" header-align="center">
              <template slot-scope="scope">
                {{scope.row.total | comdify}}
              </template>
            </el-table-column>
          </el-table>

          <Annex v-if="props.row.files && isView && props.row.files.length > 0" :fileList="props.row.files" disabled />
        </template>
      </el-table-column>
      <el-table-column prop="code" label="编号" align="center" width="180" />
      <el-table-column prop="name" label="名称" align="center">
        <!-- <template slot-scope="scope"> -->
          <!-- <div class="link" @click="handleView(scope.row)">{{scope.row.name}}</div> -->
        <!-- </template> -->
      </el-table-column>
      <el-table-column prop="workDate" label="日期" align="center" width="110">
        <template slot-scope="scope">
          {{scope.row.workDate | filter_handleDate}}
        </template>
      </el-table-column>
      <!-- <el-table-column v-for="(val, id) in showList" :key="id" :label="val.name" :align="(val.column == 'quantity' || val.column == 'ptotal') ? 'right' : 'center'" header-align="center">
        <template slot-scope="scope">
          <template v-if="val.type == 'b'">
            <template v-if="val.column == 'ptotal'">
              {{scope.row[val.column] | comdify}}
            </template>
            <template v-else>
              {{scope.row[val.column]}}
            </template>
          </template>
          <template v-else>{{scope.row.workShowMap[val.column]}}</template>
        </template>
      </el-table-column> -->
      <el-table-column prop="dealName" label="交易方" align="center" />

      <template>
        <el-table-column prop="quantity" label="数量" align="right" header-align="center" v-if="refFlowWork.costmanagetype != '7' && refFlowWork.costmanagetype != '10' && refFlowWork.costmanagetype != '4'" />
        <el-table-column prop="quantity" label="时间(天)" align="center" v-if="refFlowWork.costmanagetype == '10'" />
        <el-table-column prop="quantity" label="时间" align="center" v-if="refFlowWork.costmanagetype == '7'">
          <template slot-scope="scope">
            {{scope.row.quantity | filter_handleTimeRange}}
          </template>
        </el-table-column>
        <el-table-column prop="ptotal" label="金额" align="right" header-align="center" v-if="refFlowWork.costmanagetype != '7' && refFlowWork.costmanagetype != '10' && refFlowWork.costmanagetype != '4'">
          <template slot-scope="scope">
            {{scope.row.ptotal | comdify}}
          </template>
        </el-table-column>
      </template>
      <el-table-column label="状态" align="center" width="80">
        <template slot-scope="scope">
          <DictTag v-if="scope.row.appstatus != '3'" :options="dropDown.documentstatus" :value="scope.row.documentstatus" isStyle/>
          <el-tag v-else type="warning">审批中</el-tag>
        </template>
      </el-table-column>
      <el-table-column v-if="!isView" width="60" label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            class="del"
            @click="delData(scope.row.ofoWorkId)"
          >删除
          </el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column v-if="(refFlowWork.checkType == '1' || refFlowWork.checkType == '2')" label="进度" align="center" width="180">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.checkStatus == '0'">已核销</el-tag>
          <el-progress :percentage="scope.row.percentage" style="margin: 0" v-else-if="scope.row.openTotal != null && scope.row.percentage != 100 && scope.row.checkStatus != '0'" :format="format"></el-progress>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 关联活动对话框 -->
    <el-dialog v-dialog-drag
      title="关联活动"
      :visible.sync="dialogRefVisible"
      width="80%"
      append-to-body
      top="59px"
      class="res-dialog"
    >
      <div style="text-align: right;padding-bottom: 10px" v-if="refFlowWork.checkType === '1' || refFlowWork.checkType === '2'">
        <el-checkbox @change="changeQuery" v-model="showHx">显示已核销</el-checkbox>
      </div>
      <el-table
        :data="list"
        border
        :cell-style="{
          padding: '3px 0'
        }"
        :header-cell-style="{
          padding: '3px 0',
          background:'#F9F9FB',
          color:'#606266'
        }"
        style="width: 100%;margin-bottom:10px"
        ref="refTable"
        :default-expand-all="false">
        <el-table-column type="selection" align="center" width="50" />
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-table
              :data="props.row.ofoWorkResourceList"
              :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
              style="margin-left:50px;width:calc(100% - 50px)"
              :summary-method="(param) => getSummaries(param, ['quantity', 'total'])"
              show-summary
            >
              <el-table-column prop="ofrresourceName" label="名称"></el-table-column>
              <el-table-column prop="cbowhName" label="位置"></el-table-column>
              <el-table-column prop="quantity" label="数量" align="right" header-align="center"></el-table-column>
              <el-table-column prop="price" label="单价" align="right" header-align="center"></el-table-column>
              <el-table-column prop="total" label="金额" align="right" header-align="center">
                <template slot-scope="scope">
                  {{scope.row.total | comdify}}
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column prop="code" label="编号" align="center" width="180" />
        <el-table-column prop="name" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="workDate" label="日期" align="center" width="110">
          <template slot-scope="scope">
            {{scope.row.workDate | filter_handleDate}}
          </template>
        </el-table-column>
        <el-table-column prop="dealName" label="交易方" align="center" />
        <el-table-column prop="quantity" label="数量" align="right" header-align="center" v-if="refFlowWork.costmanagetype != '7' && refFlowWork.costmanagetype != '10' && refFlowWork.costmanagetype != '4'" />
        <el-table-column prop="quantity" label="时间(天)" align="center" v-if="refFlowWork.costmanagetype == '10'" />
        <el-table-column prop="quantity" label="时间" align="center" v-if="refFlowWork.costmanagetype == '7'">
          <template slot-scope="scope">
            {{scope.row.quantity | filter_handleTimeRange}}
          </template>
        </el-table-column>
        <el-table-column prop="ptotal" label="金额" align="right" header-align="center" v-if="refFlowWork.costmanagetype != '7' && refFlowWork.costmanagetype != '10' && refFlowWork.costmanagetype != '4'">
          <template slot-scope="scope">
            {{scope.row.ptotal | comdify}}
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="80">
          <template slot-scope="scope">
            <DictTag v-if="scope.row.appstatus != '3'" :options="dropDown.documentstatus" :value="scope.row.documentstatus" isStyle/>
            <el-tag v-else type="warning">审批中</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="(refFlowWork.checkType == '1' || refFlowWork.checkType == '2')" label="进度" align="center" width="180">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.checkStatus == '0'">已核销</el-tag>
            <el-progress :percentage="scope.row.percentage" style="margin: 0" v-else-if="scope.row.openTotal != null && scope.row.percentage != 100 && scope.row.checkStatus != '0'" :format="format"></el-progress>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChangeWork"
        background
        @current-change="handleCurrentChangeWork"
        :current-page="pageNumWork"
        :page-sizes="[10, 20, 50, 100, 200]"
        :page-size="pageSizeWork"
        layout="->, prev, pager, next, sizes, jumper, total"
        :total="totalWork"
      >
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRefVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitRefWork">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DictTag from '@/components/DictTag.vue'
import {mapState} from 'vuex'
import Annex from '@/components/project/activity/annex.vue'
import url from "@/config/url";
  export default {
    computed: {
      ...mapState({
        dropDown: state => state.dropDown.dropDown
      }),
    },
    components: {
      Annex,
      DictTag,
    },
    props: {
      workList: Array,
      ofoFlowWork: Object,
      ofoFlowDeal: Object,
      dealId:  [Number, String],
      isView: Boolean
    },
    data() {
      return {
        workList2: [],
        pageNumWork: 1,
        pageSizeWork: 10,
        dialogRefVisible: false,
        list: [],
        totalWork: 0,
        refFlowWork: {},
        refCfFlowWork: {},
        needDealQuery: true,
        showHx: false,
        needDeal: false
      }
    },
    created() {
      if (this.ofoFlowWork.refWorks) {
        this.refFlowWork = {}
        this.workList2 = this.workList ? JSON.parse(JSON.stringify(this.workList)) : []
        this.$http.get(url.getOfoFlowWorkById + this.ofoFlowWork.refWorks).then((res) => {
          if (res.data.code === 200) {
            this.refFlowWork = res.data.data
          }
        })
      } else if (this.ofoFlowWork.cfrefWorks) {
        this.refFlowWork = {}
        this.workList2 = this.workList ? JSON.parse(JSON.stringify(this.workList)) : []
        this.$http.get(url.getCfFlowWorkById + this.ofoFlowWork.cfrefWorks).then((res) => {
          if (res.data.code === 200) {
            this.refFlowWork = res.data.data
          }

        })
      }
    },
    watch: {
      workList(newValue, oldValue) {
        const list = JSON.parse(JSON.stringify(newValue))
        const ids = list.map(item => item.ofoWorkId)
        const list2 = this.workList2.filter(item => item.isWorkCheck !== '1' && ids.indexOf(item.ofoWorkId) !== -1)
        this.workList2 = [
          ...list2,
          ...list
        ];
      }
    },
    methods: {
      format (percentage) {
        return percentage === 100 ? '' : `${percentage}%`
      },
      clickRefWork () {
        this.$http.get(url.checkTwoDeal + this.ofoFlowWork.ofoFlowWorkId).then((res) => {
          if (res.data.code === 200) {
            this.needDealQuery = res.data.data === 1
            if (this.needDealQuery && !this.dealId) {
              this.$message.error(`请选择${this.ofoFlowDeal.restype1Name}`)
              return
            }
            this.dialogRefVisible = true
            this.pageNumWork = 1
            this.pageSizeWork = 10
            this.getWorkList()
          }
        })
      },
      changeQuery () {
        this.pageNumWork = 1
        this.pageSizeWork = 10
        this.getWorkList()
      },
      getWorkList() {
        this.loading = true
        if (this.ofoFlowWork.refWorks) {
          this.$http.get(url.getWorkSimpleList, {params:
            {
              ofoflowworkId: this.ofoFlowWork.refWorks,
              dealId: this.needDealQuery ? this.dealId : null,
              showHx: this.showHx,
              // ...this.siftForm,
              pageNum: this.pageNumWork,
              pageSize: this.pageSizeWork,
            }
          }).then(res => {
            this.loading = false
            if(res.data.code == 200) {
              this.list = res.data.data.list || []
              this.totalWork = res.data.data.total
            }
          })
        }else if (this.ofoFlowWork.cfrefWorks) {
          this.$http.get(url.getWorkSimpleListByCfFlowWorkId, {params:
            {
              cfflowworkId: this.ofoFlowWork.cfrefWorks,
              dealId: this.needDealQuery ? this.dealId : null,
              showHx: this.showHx,
              // ...this.siftForm,
              pageNum: this.pageNumWork,
              pageSize: this.pageSizeWork,
            }
          }).then(res => {
            this.loading = false
            if(res.data.code == 200) {
              this.list = res.data.data.list || []
              this.totalWork = res.data.data.total
            }
          })
        }

      },
      submitRefWork() {
        // this.$emit('sendrefIds', this.refIds)
        let rows = this.$refs.refTable.selection
        if(!(rows && rows.length > 0)){
          this.dialogRefVisible = false
          return
        }
        if(!this.workList2){
          this.workList2 = []
        }
        let currentIds = this.workList2.map(item => item.ofoWorkId)
        let addRows = rows.filter(item => currentIds.indexOf(item.ofoWorkId) < 0)
        this.workList2.push(...addRows)
        this.dialogRefVisible = false
      },
      selectionChangeWork(selection) {
        this.refIds = selection.map(item => item.ofoWorkId)
      },
      delData(ofoWorkId){
        this.workList2 = this.workList2.filter(item => item.ofoWorkId !== ofoWorkId)
      },
      handleSizeChangeWork(val) {
        this.pageSizeWork = val;
        this.pageNumWork = 1
        this.getWorkList()
      },
      handleCurrentChangeWork(val) {
        this.pageNumWork = val;
        this.getWorkList()
      },
      selectWork(selection, row){
        // row.ofoWorkId;
        // 清除 所有勾选项
        this.$refs.refTable.clearSelection()
        // 当表格数据都没有被勾选的时候 就返回
        // 主要用于将当前勾选的表格状态清除
        if(selection.length == 0) return
        this.$refs.refTable.toggleRowSelection(row, true);
      },
    },
  }
</script>

<style lang="scss" scoped>
.del {
  border: 0;
  color: #0C75E5;
  padding: 0;
}
</style>
